<form [formGroup]="form">
  <div class="grid grid-cols-2 gap-4">
    <sl-input label="Date" i18n-label readonly formControlName="date" type="date" hoist></sl-input>
    <sl-select multiple label="Employees" formControlName="accountIds" i18n-label hoist>
      <sl-menu-item *ngFor="let account of accounts" [value]="account.id">{{account.name}}</sl-menu-item>
    </sl-select>
    <sl-checkbox class="col-start-2" i18n formControlName="allAccounts">All employees</sl-checkbox>
  </div>

  <div class="text-right mt-8">
    <sl-button type="default" i18n (click)="cancel()">Cancel</sl-button>
    <sl-button type="primary" class="ml-4" i18n (click)="download()" [loading]="loading" [disabled]="selectedAccountIds.length == 0">Download Worksheets</sl-button>
  </div>
</form>